import { set } from 'date-fns';
import { useCallback } from 'react';
import { type DatePickerDateType, getDateType } from 'ui';
import { useParseTime } from '../../../hooks';
import { useGetParsedStartTime } from './useGetParsedStartTime';

export const useGetStartDateTime = () => {
  const getParsedStartTime = useGetParsedStartTime();
  const parseTime = useParseTime();

  return useCallback(
    ({ startDate, startTime }: { startDate: DatePickerDateType; startTime: string }): Date => {
      const date = getDateType(startDate);
      const time = getParsedStartTime(startTime);

      if (!time) {
        return date;
      }

      const parsedTime = parseTime(time);

      return set(date, {
        hours: parsedTime.getHours(),
        milliseconds: 0,
        minutes: parsedTime.getMinutes(),
        seconds: parsedTime.getSeconds(),
      });
    },
    [getParsedStartTime, parseTime],
  );
};
